<template>
    <div>
        <az-call-to-action dark @click="confirmarAlteracaoSituacao">
            {{ labelAcao }}
        </az-call-to-action>
        <az-confirm @onConfirm="alterarSituacaoUsuario" @onDecline="fecharDialog"
                    v-if="mostrarDialog" :maxWidth=320>
            {{mensagemConfirmacao}}
        </az-confirm>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'

    const ATIVO = 'ATIVO'
    const INATIVO = 'INATIVO'

    export default {
        name: 'UsuarioAcoesAtivar',
        data() {
            return {
                mostrarDialog: false
            }
        },
        computed: {
            ...mapState(['usuario']),
            labelAcao() {
                if (this.usuario.situacao === ATIVO) {
                    return 'Inativar'
                }
                return 'Ativar'
            },
            mensagemConfirmacao() {
                const acao = this.usuario.situacao === ATIVO ? 'inativar' : 'ativar'
                return `Tem certeza que deseja ${acao} o usuário?`
            }
        },
        methods: {
            ...mapActions([actionTypes.ATUALIZAR_USUARIO, actionTypes.BUSCAR_USUARIO]),
            async alterarSituacaoUsuario() {
                try {
                    this.fecharDialog()
                    await this.efetuarAlteracaoSituacao()
                    await this.sincronizarUsuario()
                    this.mostrarNotificacaoSucessoDefault()
                } catch (e) {
                    this.fecharDialog()
                }
            },
            confirmarAlteracaoSituacao() {
                this.mostrarDialog = true
            },
            definirNovaSituacao() {
                return this.usuario.situacao === ATIVO ? INATIVO : ATIVO
            },
            async efetuarAlteracaoSituacao() {
                const acaoMensagem = this.usuario.situacao === ATIVO ? 'Inativando' : 'Ativando'
                this.setMensagemLoading(`${acaoMensagem} o usuário...`)
                const usuarioPayload = Object.assign({}, this.usuario, {
                    telefone: this.removerMascaraTelefone(this.usuario.telefone),
                    situacao: this.definirNovaSituacao()
                })
                await this.atualizarUsuario(usuarioPayload)
            },
            fecharDialog() {
                this.mostrarDialog = false
            },
            async sincronizarUsuario() {
                this.setMensagemLoading('Sincronizando o usuário...')
                await this.buscarUsuario(this.usuario.id)
            }
        }
    }
</script>